import { connect } from 'react-redux';
import React from 'react';
import { navigate } from 'libs/router';

import ActionButton from 'components/buttons/action-button/ActionButton';
import Input from 'components/inputs/input/Input';
import RadioButtons from 'components/inputs/radio-buttons/RadioButtons';
import Form from 'components/form/Form';
import FormField from '../../../../components/form/form-field/FormField';

import { declineLightweightCampaign } from 'modules/access/reducers/decline-lightweight-campaign';

import { getUrlParam } from 'utils/url';
import { __t, applyTranslations, t } from 'utils/language';

applyTranslations(require('./decline-lightweight-campaign.i18n.json'));

type Props = {
  dispatch: any
};

type State = {
  token: string,
  reason: string,
  comment: string,
  reasonSelected: boolean
};

const NO_TIME_FOR_NEW_CAMPAIGNS = 'no_time_for_new_campaigns';
const CAMPAIGN_DOES_NOT_FIT_STYLE_OR_CHANNEL = 'campaign_does_not_fit_style_or_channel';
const NOT_INTERESTED_IN_THIS_BRAND = 'not_interested_in_this_brand';
const OFFER_BUDGET_TOO_LOW = 'offer_budget_too_low';
const OTHER = 'other';

const REASON_OPTIONS = [NO_TIME_FOR_NEW_CAMPAIGNS, CAMPAIGN_DOES_NOT_FIT_STYLE_OR_CHANNEL, NOT_INTERESTED_IN_THIS_BRAND, OFFER_BUDGET_TOO_LOW, OTHER];

class DeclineLightweightCampaignForm extends React.Component<Props, State> {
  state: State = {
    token: getUrlParam('token') as string,
    reason: '',
    comment: '',
    reasonSelected: true
  };

  handleSubmit = () => {
    const { dispatch } = this.props;
    if (this.state.reason === '') {
      this.setState((state) => ({
        ...state,
        reasonSelected: false
      }));
    } else {
      dispatch(declineLightweightCampaign({
        token: this.state.token,
        reason: this.state.reason,
        comment: this.state.comment
      }))
        .then(() => navigate.to('/decline-invite/success'));
    }
  };

  getReasons = () => REASON_OPTIONS.map((option) => ({
    value: option,
    name: __t(`decline_lightweight_campaign.reasons.${option}`)
  }));

  handleChange = (reason: string) => {
    this.setState((prevState) => ({
      ...prevState,
      reason,
      reasonSelected: true
    }));
  };

  handleCommentChange = (event) => {
    const input = event.target;
    const value = (input instanceof HTMLTextAreaElement && input.value) || '';
    this.setState((prevState) => ({
      ...prevState,
      comment: String(value)
    }));
  };

  render() {
    const { reasonSelected, reason } = this.state;

    return (
      <div>
        <div>
          <div className="decline-lightweight-campaign__title">{__t('decline_lightweight_campaign.heading')}</div>
        </div>
        <div>
          <div className="decline-lightweight-campaign__message">{__t('decline_lightweight_campaign.message')}</div>
        </div>
        <Form
          onSubmit={this.handleSubmit}
        >
          <FormField
            key="reason"
            showRequiredMark
            label={t('decline_lightweight_campaign.reason')}
            direction="column"
            className="decline-lightweight-campaign__label"
          >
            <RadioButtons
              direction="column"
              selected={reason}
              options={this.getReasons()}
              onChange={this.handleChange}
            />
            {
              !reasonSelected && (
                <div className="decline-lightweight-campaign__reason_missing">{__t('decline_lightweight_campaign.reason_missing_error')}</div>
              )
            }
          </FormField>
          {
              reason === OTHER && (
                <Input
                  value={this.state.comment}
                  name="comment"
                  multiline
                  width="responsive"
                  className="decline-lightweight-campaign__comment"
                  onChange={this.handleCommentChange}
                />
              )
            }
          <div className="decline-lightweight-campaign__action">
            <ActionButton
              color="primary"
              onClick={this.handleSubmit}
            >
              {__t('decline_lightweight_campaign.decline_campaign')}
            </ActionButton>
          </div>
        </Form>
      </div>
    );
  }
}

export default connect()(DeclineLightweightCampaignForm);
